import custController from '../../../controllers/rateController/controller';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
export default {
    name: 'SimpleTable',
    data(){
        return {
            periode: 'all',
            isRecaptchaVisible: false,
            isRecaptchaVerified: false,
            recaptchaResponse: null,
            currentStep: 1,
            custList: [],
            currentPage: 1,
            pageSize: 10,
            totalPages: 0,
            totalCust: 0, // Total items dari backend
            searchQuery: '',
            cust: {
                name: '',
                name_company: '',
                email: '',
                phone: '',
            },
            rateList: [],
            selectedCust: {
                id: '',
                name_rater: '',
                name_company: '',
                email: '',
                no_hp: '',
                quetion_id: '',
                answer_id: '',
                score: ''
            },
        }
    },
    computed: {
        filteredCust() {
            return this.custList.filter((cust) => {
                return cust.name_rater.toLowerCase().includes(this.searchQuery.toLowerCase());
            })
        },
        pages(){
            return Math.ceil(this.totalCust / this.pageSize);
        },
        displayedPages() {
            const range = 1; // Jarak halaman dari currentPage (kiri dan kanan)
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            // Tampilkan "..." di awal jika halaman pertama tidak ditampilkan
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            // Tampilkan "..." di akhir jika halaman terakhir tidak ditampilkan
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    watch: {
        searchQuery: {
            handler: 'fetchCust', // Nama metode yang dipanggil setiap searchQuery berubah
            immediate: true,     // Menjalankan handler saat komponen dimuat
        },
    },
    methods: {
        showRecaptcha() {
          this.isRecaptchaVisible = true;
          this.$nextTick(() => {
            window.grecaptcha.render(document.querySelector('.g-recaptcha'), {
              sitekey: "6LcPGP8qAAAAAHhi2i81rKfnV-OsQAN7NvXrbDIR",
              callback: this.onRecaptchaSuccess
            });
          });
        },
        onRecaptchaSuccess(response) {
          console.log("reCAPTCHA verified:", response);
          this.isRecaptchaVerified = true;
          this.recaptchaResponse = response;
        },
        showModal(type, id) {
            const selectedCust = this.custList.find(cust => cust.id === id);
            if (selectedCust) {
                this.selectedCust = selectedCust;
                console.log(this.selectedCust)
                
                const modal = document.getElementById(type === 'edit' ? 'editCust' : 'detailCust');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
          const modalIds = ['tambahCust', 'editCust', 'detailCust'];
          modalIds.forEach(id => {
            const modal = document.getElementById(id);
            if (modal && modal.classList.contains('show')) {
              modal.classList.remove('show');
              setTimeout(() => {
                modal.style.display = 'none';
              }, 300);
            }
          });
        
          // Hapus backdrop
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(backdrop => {
            backdrop.classList.remove('show');
            setTimeout(() => {
              if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
              }
            }, 300);
          });
        
          // Hapus kelas atau atribut yang mengunci scroll pada body
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.overflow = ''; // Menghapus properti overflow jika ada
          this.fetchCust();
        },    
        resetForm() {
            this.cust = {
                name_c_feedback: '',
                rating: '',
                comment: '',
                status: '',
                created_on: ''
            };
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchCust();
            }
        },
        async fetchCust() {
            try {
                const period = this.periode;
                console.log(period);
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await custController.fetchCust(period, query, this.currentPage, this.pageSize);
                this.custList = response.data;
                this.totalAllCust();
            } catch (error) {
                console.error('Error fetching services:', error);
                throw error;
            }
        },
        nextStep() {
          if (this.currentStep < 3) {
              this.currentStep++;
          }
          this.fetchQuestion();
        },
        prevStep() {
            if (this.currentStep > 1) {
                this.currentStep--;
            }
        },
        async fetchQuestion(){
            try {
                const response = await custController.fetchQuestion();
                this.rateList = response.data;
                console.log(this.rateList);
            } catch (error) {
                console.error('Error fetching services:', error);
                throw error;
            }
        },
        async totalAllCust() {
            try {
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await custController.totalAllCust(query);
                this.totalCust = response.data;
            } catch (error) {
                console.error('Error fetching customers:', error);
                throw error;
            }
        },
        async addCust() {
            try {
              if (!this.recaptchaResponse) {
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: 'Silahkan verifikasi reCAPTCHA',
                  timer: 1500
                })
                return;
              }
              const tipe = 'Admin';
              const name = this.cust.name;
              const name_company = this.cust.name_company;
              const email = this.cust.email;
              const phone = this.cust.phone;
              const token = this.recaptchaResponse;
              const data = [];
              this.rateList.forEach((x, questionIndex) => {
                x.answers.forEach((y, answerIndex) => {
                  const answer = document.querySelector(`input[data-question="${questionIndex}"][data-answer="${answerIndex}"]`);
                  if (y.answer_type === 'text') {
                    data.push({
                      question_id: x.id,
                      answer_id: y.id,
                      answer: answer.value
                    });
                  } else if (y.answer_type === 'radio') {
                    const radio = document.querySelector(`input[name="radio-${questionIndex}"][value="${y.answer}"]:checked`);
                    if (radio) {
                      data.push({
                        question_id: x.id,
                        answer_id: y.answer_id,
                        score: y.score,
                        answer: y.answer
                      });
                    }
                  }
                });
              });
              const add = data.map(({ question_id, answer_id, score, answer }) => ({
                name: name,
                name_company: name_company,
                email: email,
                phone: phone,
                question_id,
                answer_id,
                score,
                answer,
                token: token,
                tipe: tipe,
                newDate: new Date().toISOString().slice(0, 19).replace('T', ' ')
              }));
              const response = await custController.addCust(add);
              console.log(response);
              if (response.status === 200) {
                Swal.fire({
                  icon: 'success',
                  title: 'Berhasil menambahkan data',
                  timer: 1500
                })
                this.fetchCust();
                this.closeModal();
                this.resetForm();
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Gagal menambahkan data',
                  timer: 1500
                });
              }
            } catch (error) {
              console.error('Error submitting data:', error);
            } 
        },
        async downloadRateList() {
          const periode = this.periode;
          const response = await custController.downloadRateList(periode);
          const worksheet = XLSX.utils.json_to_sheet(response);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Rate");
          XLSX.writeFile(workbook, "Rate List.xlsx");
      }

    },

}